import { IGlobalState } from '~reducer';
import { IDictionary } from '~utilities/IDictionary';
import ILoanPaymentAba from '~Api/LoanPaymentAba/ILoanPaymentAba';
import ILoanPaymentAbaHistory from '~Api/LoanPaymentAba/ILoanPaymentAbaHistory';
import IWarehouseLoanTransaction from '~Api/Warehouse/IWarehouseLoanTransaction';
import { keyMap } from '~utilities/utils';
import _ from 'lodash';
import { warehouseLoanTransactionSelector } from '~Warehouses/selectors';

export function loanPaymentAbaSelector(state: IGlobalState, loanPaymentAbaUuid: string): ILoanPaymentAba {
    return state.loanPaymentAbas.loanPaymentAbas[loanPaymentAbaUuid];
}

export function loanPaymentAbasSelector(state: IGlobalState): IDictionary<ILoanPaymentAba> {
    if (!state.loanPaymentAbas.loanPaymentAbasListed) {
        return null;
    }

    return state.loanPaymentAbas.loanPaymentAbas;
}

export function loanPaymentAbaHistoriesSelector(state: IGlobalState, loanPaymentUuid: string): ILoanPaymentAbaHistory[] {
    return state.loanPaymentAbas.histories[loanPaymentUuid];
}

export function loanPaymentAbasUnallocatedWarehouseLoanTransactionsSelector(state: IGlobalState): IDictionary<IWarehouseLoanTransaction> {
    if (!state.loanPaymentAbas.unallocatedWarehouseLoanTransactionUuids) {
        return null;
    }

    const unallocatedWarehouseLoanTransactions: IDictionary<IWarehouseLoanTransaction> = {};

    _.each(state.loanPaymentAbas.unallocatedWarehouseLoanTransactionUuids, (warehouseLoanTransactionUuid: string) => {
        unallocatedWarehouseLoanTransactions[warehouseLoanTransactionUuid] = warehouseLoanTransactionSelector(state, warehouseLoanTransactionUuid);
    });

    return unallocatedWarehouseLoanTransactions;
}

export function loanPaymentAbaWarehouseLoanTransactionsSelector(state: IGlobalState, loanPaymentUuid: string): IDictionary<IWarehouseLoanTransaction> {
    if (!state.loanPaymentAbas.loanPaymentAbaWarehouseLoanTransactionUuids[loanPaymentUuid]) {
        return null;
    }

    return keyMap(state.loanPaymentAbas.loanPaymentAbaWarehouseLoanTransactionUuids[loanPaymentUuid], 'uuid', (warehouseLoanTransactionUuid: string) => warehouseLoanTransactionSelector(state, warehouseLoanTransactionUuid));
}
